<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill="#6783B2">
        <g>
          <path
            d="M11.146.146c.196-.195.512-.195.708 0l4 4c.195.196.195.512 0 .708l-10 10c-.07.07-.16.117-.256.136l-5 1c-.35.07-.658-.238-.588-.588l1-5c.02-.097.067-.186.136-.256zM9 3.706L1.96 10.745l-.824 4.117 4.117-.823L12.293 7 8.999 3.706zM11.5 1.207L9.706 2.999 13 6.293 14.793 4.5 11.5 1.207z"
            transform="translate(-8 -8) translate(8 8)"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'EditIcon',
  props: {
    height: VueTypes.string.def('16'),
    width: VueTypes.string.def('16'),
  },
};
</script>

<style lang="scss"></style>
